import { EntityType } from 'common/types';
import {
  enterpriseAnalyticsDataLoadLookerDashboard,
  purchasesDataCsvDownload,
  purchasesErrorCsvDownload,
} from 'core/telemetry/avo/Avo';

export const telemetryLoadLookerDashboardDuration = (durationMs: number) => {
  enterpriseAnalyticsDataLoadLookerDashboard({
    durationMs,
  });
};

export const purchaseCsvDownloadView = (
  downloadTimeMs: number,
  businessName: string,
  venuesCount: number,
  entityType: EntityType,
  numOfDays: number,
  entityId: string,
  rangeStartDaysAgo: number,
  rangeEndDaysAgo: number,
) => {
  purchasesDataCsvDownload({
    businessName,
    venuesCount,
    entityType,
    numOfDays,
    downloadTimeMs,
    entityId,
    rangeStartDaysAgo,
    rangeEndDaysAgo,
  });
};

export const purchaseCsvDownloadError = (
  businessName: string,
  venuesCount: number,
  entityType: EntityType,
  numOfDays: number,
  entityId: string,
  rangeStartDaysAgo: number,
  rangeEndDaysAgo: number,
  errorType: string,
) => {
  purchasesErrorCsvDownload({
    businessName,
    venuesCount,
    entityType,
    numOfDays,
    entityId,
    rangeStartDaysAgo,
    rangeEndDaysAgo,
    errorType,
  });
};
